export class WorkspaceAllowedPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "principal",
            "baseName": "principal",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<WorkspaceStoragePermission>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceAllowedPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
